"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _operators = _interopRequireDefault(require("../operators.js"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _FieldBlock = _interopRequireDefault(require("../../../../components/FieldBlock"));

var _common = _interopRequireDefault(require("../../../../styles/common.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Operator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Operator, _React$Component);

  function Operator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Operator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Operator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var dataConnector = _this.props.dataConnector;

      if ((0, _find2.default)(_operators.default[dataConnector.type], {
        code: e.target.value
      })) {
        _this.props.field.onChange(e.target.value);
      } else {
        _this.props.field.onChange('0');
      }
    });

    return _this;
  }

  _createClass(Operator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataConnector = _this$props.dataConnector,
          field = _this$props.field;

      if (!dataConnector) {
        return null;
      }

      return _react.default.createElement("div", {
        className: _common.default.lastRow
      }, _react.default.createElement(_FieldBlock.default, {
        field: field,
        label: ""
      }, _react.default.createElement("select", {
        className: "form-control",
        style: {
          width: 'auto'
        },
        onChange: this.onChange,
        value: field.value
      }, _react.default.createElement("option", {
        key: "no_value",
        value: "0"
      }, "- choose operator -"), _operators.default[dataConnector.type].map(function (operator) {
        return _react.default.createElement("option", {
          key: operator.code,
          value: operator.code
        }, operator.title);
      }))));
    }
  }]);

  return Operator;
}(_react.default.Component);

exports.default = Operator;

_defineProperty(Operator, "propTypes", {
  dataConnector: _propTypes.default.object,
  field: _propTypes.default.object
});